import moment from "moment";
const cardValidate = require('card-validator');


interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    validate: boolean
}

const errors: {
    [key: string]: string
} = {
    number: "Please add card number.",
    numberValid: "Credit card number entered is not valid.",
    exp_year: "Please add expiration date.",
    exp_year_invalid: "Your card's expiration date is invalid.",
    exp_month_invalid: "Your card's expiration date is invalid.",
    exp_month: "Please add expiration date.",
    cvc: "Please add cvc.",
    postal_code: "Please add zip code."
};

export default (data: any, action: Action) => {
    const newForm = data;
    const prop = newForm[action.field];

    const stProp = action?.value || '';
    const length = stProp.toString().length || 0;

    let valid = false;
    if (prop) {
        const currentYear = moment().format('YY'),
            currentMonth = moment().format('MM');

        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }
        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }
        if (action.field === 'number' && action.value) {
            const {isValid, card, isPotentiallyValid}: any = cardValidate.number(action.value);
            prop.cardType = card && card.type;
            prop.error = !isValid ? errors.numberValid : null;
            prop.value = action.value.length ? action.value.replace(/\s/g, '') : '';
        } else if (action.field === 'exp_year' && action.value) {
            prop.error = action.value < parseInt(currentYear) || action.value === parseInt(currentYear) && newForm.exp_month.value < parseInt(currentMonth) ? errors.exp_year_invalid : '';
            prop.value = action.value;
        } else if (action.field === 'exp_month' && action.value) {
            prop.error = action.value > 12 || action.value < parseInt(currentMonth) && newForm.exp_year.value === parseInt(currentYear)  ? errors.exp_month_invalid : '';
            prop.value = action.value;
        } else {
            prop.error = (prop.added && !action.value && prop.required) || (action.value && prop.min && prop.min > length) ? errors[action.field] : null;
            prop.value = action.value;
        }
        //
        const paymentMethod = action.field === 'paymentMethod' && action.value;
        const vals = Object.values(newForm).filter((f: any) => f.required);
        const valids = vals.filter((f: any) => f.added && f.value && !f.error);
        valid = paymentMethod || vals.length === valids.length;
    }

    return {
        changed: true,
        valid,
        data: newForm,
    };
};
